import Plotly from 'plotly.js-basic-dist';
import createPlotlyComponent from 'react-plotly.js/factory';

/**
 * A custom Plotly component that only imports the necessary Plotly components
 * Available plot types: bar, scatter
 *
 * @concussionrx
 */
export const CRxPlotlyComponentReference = createPlotlyComponent(Plotly);
export const CRxPlotlyReference = Plotly;
